import React from 'react';
import RequirementGrid from '../components/RequirementGrid';

const pageProfileGridNoEdit = (props) => <RequirementGrid id={props.id} />;

export default pageProfileGridNoEdit;
